export function isEntityClean(e) {
  if (typeof e !== "object" || e === null) {
    return true;
  }
  let isClean = true;
  for (const [key, val] of Object.entries(e)) {
    if (key === "id") continue;
    if (key === "_isClean") continue;
    if (val) {
      isClean = false;
      break;
    }
  }
  return isClean;
}
